import { Character } from '@/types';
import Api from './Api';

class _CharacterApi extends Api {
    storeCharacter(data: Character): Promise<any> {
        return this.getHttpClient().post(`character/store`, data);
    }

    removeCharacter(data: Character): Promise<any> {
        return this.getHttpClient().post(`character/remove`, data);
    }

    updateCharacter(data: Character): Promise<any> {
        return this.getHttpClient().post(`character/update`, data);
    }

    loadCharacterColors(): Promise<any> {
        return this.getHttpClient().post(`color/list`);
    }
}

export const CharacterApi = new _CharacterApi();
